export * from './encabezado.pipe';
export * from './linea.pipe';
export * from './membrete.pipe';
export * from './pie.pipe';
export * from './referencia.pipe';
export * from './titulo.pipe';
